module.exports = __webpack_public_path__ + "static/media/task3Planet3.6343b815.png";